import { render, staticRenderFns } from "./FpuiInputFileZone.vue?vue&type=template&id=6be58a62&lang=pug&"
import script from "./FpuiInputFileZone.vue?vue&type=script&lang=js&"
export * from "./FpuiInputFileZone.vue?vue&type=script&lang=js&"
import style0 from "./FpuiInputFileZone.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports